import { reactive } from 'vue';

/**
 * ที่พักไฟล์ export ของ Tax Log V2 ที่เปิดอยู่ในหน้า `/TaxLogV2/offline` — **read-only holder**
 * ══════════════════════════════════════════════════════════════════════════════════════════════════
 *
 * reactive singleton ธรรมดา (house style เดียวกับ store อื่นใน `utils/`) มีแค่ "ไฟล์ที่เปิดอยู่" + ชื่อไฟล์
 * · `file` = envelope ที่ผ่าน `parseTaxLogExport()` (`utils/taxLogOfflineFile.js`) มาแล้วเท่านั้น
 * · ไม่มีใครเขียนทับเนื้อไฟล์ — หน้า Detail อ่านผ่าน `createOfflineTaxLogApi(file)` ซึ่งไม่ mutate
 *
 * 🔴 **ไม่เก็บลง localStorage / sessionStorage โดยเจตนา** — ไฟล์หนึ่ง session ใหญ่ได้หลายสิบ MB
 * (≈150–350 KB ต่อเทิร์น) เกินเพดาน storage ของ browser ⇒ refresh หน้า = ข้อมูลหาย ต้องเลือกไฟล์ใหม่
 * (หน้า offline มี picker ในตัวสำหรับกรณีนี้)
 *
 * ⚠️ ห้าม import store นี้ข้ามไปหน้าอื่นเพื่อ "จำไฟล์ไว้" — มันมีไว้ส่งไฟล์จาก picker ไปหน้า Detail โหมด offline เท่านั้น
 */
export const taxLogOfflineStore = reactive({
  /** @type {Object|null} envelope ที่ parse แล้ว · `null` = ยังไม่ได้เลือกไฟล์ */
  file: null,
  /** ชื่อไฟล์ที่ผู้ใช้เลือก (แสดงใน banner) */
  fileName: '',
});

/**
 * ตั้งไฟล์ที่เปิดอยู่
 * @param {Object} file envelope จาก `parseTaxLogExport(...).file`
 * @param {string} [fileName]
 */
export function setOfflineTaxLog(file, fileName) {
  taxLogOfflineStore.file = file || null;
  taxLogOfflineStore.fileName = file ? String(fileName || '') : '';
}

/** ปิดไฟล์ (กลับไปหน้าเลือกไฟล์) */
export function clearOfflineTaxLog() {
  taxLogOfflineStore.file = null;
  taxLogOfflineStore.fileName = '';
}
